import PageTitleLayout from './PageTitleLayout';

export default PageTitleLayout;
